import React, { memo, useEffect, useState } from 'react';
import styles from './styles.module.css';
import { Table, Loading } from '../../../../../common/ui';
import { getCategories } from '../../actions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const CategoryTable = memo(
  ({
    getCategories,
    auth: { branchId },
    categoriesState: { categoriesData, isLoading },
    searchTerm = '',
  }) => {
    const [filterParams, setFilterParams] = useState({});

    useEffect(() => {
      const params = { ...filterParams };
      if (searchTerm && searchTerm.trim()) {
        params.name = { like: `%${searchTerm.trim()}%` };
      }
      if (branchId) {
        getCategories(params);
      }
    }, [filterParams, branchId, searchTerm, getCategories]);

    const columns = [
      { id: 'name', label: 'Name', minWidth: 100 },
      {
        id: 'datecreated',
        label: 'Date Created',
        minWidth: 100,
        format: (value) => (value != null ? String(value) : ''),
      },
      {
        id: 'options',
        minWidth: 20,
        options: ['Update'],
        table: 'category',
      },
    ];

    return (
      <div className={styles.wrapper}>
        {isLoading ? (
          <div className={styles.loadingWrap}>
            <Loading variant="inline" label="" />
          </div>
        ) : (
          <Table columns={columns} rows={categoriesData || []} />
        )}
      </div>
    );
  }
);

CategoryTable.propTypes = {
  getCategories: PropTypes.func.isRequired,
  auth: PropTypes.shape({
    branchId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  categoriesState: PropTypes.shape({
    categoriesData: PropTypes.array,
    isLoading: PropTypes.bool,
  }).isRequired,
  searchTerm: PropTypes.string,
};

const mapStateToProps = (state) => ({
  auth: state.authState,
  categoriesState: state.categoriesState,
});

export default connect(mapStateToProps, {
  getCategories,
})(CategoryTable);
